import { render, staticRenderFns } from "./KeyStatBox.vue?vue&type=template&id=7dec1122&scoped=true&lang=pug&"
import script from "./KeyStatBox.vue?vue&type=script&lang=js&"
export * from "./KeyStatBox.vue?vue&type=script&lang=js&"
import style0 from "./KeyStatBox.vue?vue&type=style&index=0&id=7dec1122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dec1122",
  null
  
)

export default component.exports